import { useCallback, useEffect, useState } from "react";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import "dayjs/locale/vi";
import { ControlForm } from "../../../components";
import InputForm from "../../../components/controls/InputForm";
import ModalCustom from "../../../components/Modal";
import ConversationService from "../../../services/api/conversation.service";
import { IUpdateGroupTitleReq } from "../../../models/conversation";
import { useTranslation } from "react-i18next";

interface EditNameGroupChat {
  id: string;
  title: string;
}

interface IProps {
  data?: IUpdateGroupTitleReq;
  open: boolean;
  onCreateSuccess?: () => void;
  handleClose: () => void;
}

const EditNameGroupChat = ({ open, handleClose, data }: IProps) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t("Chat.PleaseEnterTheGroupName"))
  }) as any;
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<EditNameGroupChat>({
    defaultValues: {
      title: ""
    },
    resolver: yupResolver(validationSchema)
  });

  useEffect(() => {
    data && setValue("title", data.title);
  }, [data]);

  const handSubmitEditNameGroupChat = async (
    editNameGroupChat: EditNameGroupChat
  ) => {
    const id = data?.id && data.id;

    const dataUpdate: IUpdateGroupTitleReq = {
      id: id ?? "",
      title: editNameGroupChat.title
    };

    await ConversationService.updateGroupTitleAsync(dataUpdate);

    handleClose();
  };

  return (
    <ModalCustom
      title={t("Chat.EditConversationName")}
      textSubmit={t("Modal.SubmitText")}
      textClose={t("Modal.CancelText")}
      open={open}
      onSubmit={handleSubmit(handSubmitEditNameGroupChat)}
      onClose={handleClose}
    >
      <ControlForm
        title={t("Chat.ConversationName")}
        classname="brand-form"
        isRequired
      >
        <InputForm
          placeholder={t("Chat.ConversationName")}
          required
          name="title"
          errors={errors}
          control={control}
          inputProps={{
            style: {
              fontSize: 14,
              fontWeight: 500
              //color: "#596970",
              // textTransform: "uppercase"
            }
          }}
          size="small"
        />
      </ControlForm>
    </ModalCustom>
  );
};

export default EditNameGroupChat;
